import { BaseFetch } from "../main-model"
export default class ParcelModel extends BaseFetch {
    getAmountAssetBy = (data) =>
        this.authFetch({
            url: "parcel/getAmountAssetBy",
            method: "POST",
            body: JSON.stringify(data),
        })   

        getAssetSchoolById = (data) =>
        this.authFetch({
            url: "parcel/getAssetSchoolById",
            method: "POST",
            body: JSON.stringify(data),
        })   
        getAssetSchoolYear = (data) =>
        this.authFetch({
            url: "parcel/getAssetSchoolYear",
            method: "POST",
            body: JSON.stringify(data),
        })   
        getAssetSchoolByYear = (data) =>
        this.authFetch({
            url: "parcel/getAssetSchoolByYear",
            method: "POST",
            body: JSON.stringify(data),
        })   
        getAsset = (data) =>
        this.authFetch({
            url: "parcel/getAsset",
            method: "POST",
            body: JSON.stringify(data),
        })   
}
